// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3hsLH","title":"Header_title__vqiK7","side":"Header_side__2LyYM"};